<div class="row pt-4">
    <div class="col-md-12">
        <div class="card p-3">
            <form role="form" [formGroup]="formParamIntegracao" (ngSubmit)="submit()">
                <h5 class="mb-0">Cadastro/edição da Integração</h5> <hr>
                <div class="container">
                    <div class="row">    
                        <div class="form-group col-md-3">
                            <strong>Plataforma *</strong>
                            <select class="form-control" formControlName="plataformaId">
                                <option disabled value="">Selecione</option>
                                <option *ngFor="let p of listaPlataformas"
                                    value="{{p.id}}">
                                    {{p.nome}}
                                </option>
                            </select>
                        </div>
                    </div>
                <div class="row">
                    <div class="form-group col-md-3">
                        <strong><label for="exampleInputLogin">Login Autenticação Integração</label></strong>
                        <input id="login" type="text" class="form-control" formControlName="login">
                    </div>
                    <div class="form-group col-md-3">
                        <strong><label for="exampleInputLogin">Senha Autenticação Integração</label></strong>
                        <input id="senha" type="password" class="form-control" formControlName="senha">
                    </div>
                    <div class="card p-12">
                        <div class="form-group col-md-12">
                            <strong><label for="exampleInputLogin">Chave Pública RSA</label></strong>
                            <input id="publicKey" type="file" (change)="handleInputChange($event,'publicKey')" class="form-control" accept="text/*" >
                            <div *ngIf="chavePublicaTexto">
                                <pre>{{ chavePublicaTexto }}</pre>
                            </div>
                            <strong><label for="exampleInputLogin">Chave Privada RSA</label></strong>
                            <input id="privateKey" type="file" (change)="handleInputChange($event,'privateKey')" class="form-control" accept="text/*">
                            <div *ngIf="chavePrivadaTexto">
                                <pre>{{ chavePrivadaTexto }}</pre>
                            </div>
                        </div>
                      
                </div>
               
                    
            
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong><label for="exampleInputLogin">URL Integração *</label></strong>
                        <input id="url" type="url" class="form-control" formControlName="url">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong><label for="exampleInputLogin">URL Senha *</label></strong>
                        <input id="alterarSenhaUrl" type="url" class="form-control" formControlName="alterarSenhaUrl">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong><label for="exampleInputLogin">URL Logout </label></strong>
                        <input id="logoutUrl" type="url" class="form-control" formControlName="logoutUrl">
                    </div>
                </div>
                <h5 class="mb-0">Textos de erro</h5> <hr>
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong><label for="exampleInputLogin">Fora do período eleitoral</label></strong>
                        <input id="logoutUrl" type="url" class="form-control" formControlName="textoForaDoPeriodoEleitoral">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong><label for="exampleInputLogin">Sem acesso a candidatura</label></strong>
                        <input id="logoutUrl" type="url" class="form-control" formControlName="textoSemAcessoCandidatura">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong><label for="exampleInputLogin">Sem acesso a votação</label></strong>
                        <input id="logoutUrl" type="url" class="form-control" formControlName="textoSemAcessoVotacao">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <strong><label for="exampleInputLogin">Sessão Expirada</label></strong>
                        <input id="logoutUrl" type="url" class="form-control" formControlName="textoSessaoExpirada">
                    </div>
                </div>
               
                
            </div>               
                <button type="submit" class="btn btn-success btn-custom" [disabled]="btOff">Salvar</button>
            </form>
        </div>
    </div>
</div>